angular
	.module 'App.Repository'
	.factory 'ShopGroupRepository',
		[
			'BaseRepository',
			(BaseRepository) ->
				class ShopGroupRepository extends BaseRepository
					@resource = '/shop_groups'
					@isRestricted = true

					findByQuery: (query = null) ->
						if _.isEmpty(query)
							query = @createQuery()

						if !query.isSorted()
							query.sortBy 'name', 'ASC'

						super(query)

				return new ShopGroupRepository()
		]
